export const asset = {
  'with-asset-wrapper': {
    position: "relative",
    bgColor: "white",
    minHeight: "50px",
    padding: "12px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "md",
    transition: "0.15s ease border",
    overflow: "hidden",
  },
  'with-selectable-asset': {
    _hover: {
      borderColor: 'brand.500',
      cursor: 'pointer',
    }
  },
  'with-selectable-text-asset': {
    _hover: {
      borderColor: 'brand.500',
      cursor: 'pointer',
      padding: '12px',
    }
  },
  'with-quick-actions': {
    position: "absolute",
    top: "11px",
    right: "10px",
    display: "grid",
    gap: "6px"
  }
};
